import { APIResponse } from '@src/types/common/api'
import { LoginRes, TwitterBind, TwitterCredentials } from '@src/types/account'
import { request } from './request'

export async function login(data: {
  wallet: string
  signature: string
  referralCode?: string
}): Promise<APIResponse<LoginRes>> {
  return request.post('/auth/solana-login', data)
}
export async function getNonce(wallet: string): Promise<APIResponse<{ nonce: string }>> {
  return request.get('/auth/crypto-nonce', { params: { wallet } })
}

export async function getTwitterAuthUrl(): Promise<APIResponse<{ url: string }>> {
  return request.get('/twitter/auth-link')
}
export async function bindTwitter(data: TwitterBind): Promise<APIResponse<void>> {
  return request.post('/twitter/bind-callback', data)
}
export async function unbind(id: number): Promise<APIResponse<void>> {
  return request.put(`/twitter/unbind/${id}`)
}
export async function checkTwitterAuth(
  data: TwitterCredentials,
): Promise<APIResponse<{ id: string }>> {
  return request.post('/twitter/check-customize-auth', data)
}
export async function setTwitterCustomizeAuth(
  data: TwitterCredentials & { agentId: number },
): Promise<APIResponse<void>> {
  return request.post('/twitter/setting-customize-auth', data)
}
export async function unbindTwitterCustomizeAuth(agentId: number): Promise<APIResponse<void>> {
  return request.post('/twitter/unbind-customize-auth', { agentId })
}

export async function googleLogin(data: {
  token: string
  referralCode?: string
}): Promise<APIResponse<LoginRes>> {
  return request.post('/auth/google-login', data)
}
